<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$info"
				start
			/>
			<translate>General Info</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col
					cols="12"
					lg="6"
				>
					<v-text-field
						:model-value="date"
						:label="$gettext('Date')"
						hide-details
						readonly
						variant="outlined"
						density="compact"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					cols="12"
					lg="8"
				>
					<label><translate>Device</translate></label><br>
					<a :href="`/bo/orders/view?id=${orderrow.orderId}`">
						{{ orderrow.phoneBrand }}
						{{ orderrow.phoneModel }}
					</a>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					v-if="currentDevice.imei"
					cols="12"
					lg="6"
				>
					<label><translate /></label>

					<v-text-field
						:label="$gettext('Current IMEI')"
						hide-details
						readonly
						:model-value="currentDevice.imei"
						variant="outlined"
						density="compact"
					/>
				</v-col>
				<v-col
					v-if="originalDevice && originalDevice.imei"
					cols="12"
					lg="6"
				>
					<v-text-field
						:label="$gettext('Original IMEI')"
						hide-details
						disabled
						:model-value="originalDevice.imei"
						variant="outlined"
						density="compact"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					v-if="currentDevice.deviceSerialNumber"
					cols="12"
					lg="6"
				>
					<label><translate /></label>

					<v-text-field
						:label="$gettext('Current Serial Number')"
						hide-details
						variant="outlined"
						:model-value="currentDevice.deviceSerialNumber"
						density="compact"
					/>
				</v-col>
				<v-col
					v-if="originalDevice && originalDevice.serialNumber"
					cols="12"
					lg="6"
				>
					<v-text-field
						:label="$gettext('Original Serial Number')"
						hide-details
						disabled
						:model-value="originalDevice.serialNumber"
						variant="outlined"
						density="compact"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					v-if="currentDevice.ean"
					cols="12"
					lg="6"
				>
					<v-text-field
						:label="$gettext('Current EAN')"
						hide-details
						variant="outlined"
						:model-value="currentDevice.ean"
						density="compact"
					/>
				</v-col>
				<v-col
					v-if="originalDevice && originalDevice.ean"
					cols="12"
					lg="6"
				>
					<v-text-field
						:label="$gettext('Original EAN')"
						hide-details
						disabled
						:model-value="originalDevice.ean"
						variant="outlined"
						density="compact"
					/>
				</v-col>
			</v-row>
			<v-row v-if="orderrow.phonePurchasePrice">
				<v-col
					cols="12"
					lg="6"
				>
					<price-field
						ref="price"
						v-model="purchasePrice"
						:label="$gettext('Purchase Value')"
						:readonly="!purchasePriceUpdatePermission"
						:append-inner-icon="purchasePriceUpdatePermission ? '$pencil' : ''"
						density="compact"
					/>
				</v-col>
				<v-col
					v-if="purchasePriceUpdatePermission"
					cols="12"
					lg="6"
				>
					<v-btn
						variant="outlined"
						@click="updatePurchaseValue"
					>
						<translate>Edit Purchase Value</translate>
					</v-btn>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col
					cols="12"
					lg="6"
				>
					<label><translate>Insurance</translate></label><br>
					<a :href="`/bo/products/view?id=${product.id}`">{{ product.name }} (Version {{ orderrow.productVersionId }})</a>
				</v-col>
				<v-col
					v-if="orderrow.priceId"
					cols="12"
					lg="6"
				>
					<label><translate>Price ID</translate></label><br>
					{{ orderrow.priceId }}
				</v-col>
				<v-col
					v-else
					cols="12"
					lg="6"
				>
					<label><translate>Price ID</translate></label><br>
					<translate>None</translate>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';

export default {
	name: 'GeneralInfoCard',
	props: {
		date: {
			type: String,
			required: true
		},
		orderrow: {
			type: Object,
			required: true
		},
		currentDevice: {
			type: Object,
			required: false,
			default: () => ({
			}),
		},
		originalDevice: {
			type: Object,
			required: false,
			default: null,
		},
		product: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			purchasePriceUpdatePermission: localStorage.getItem('permissions').includes('orderrow.purchase_price_phone.update'),
			purchasePrice: ''
		};
	},

	created () {
		this.purchasePrice = Number(this.orderrow.phonePurchasePrice).toFixed(2);
	},

	methods: {
		/**
		 * Update the phone purchase value of an orderrow
		 */
		updatePurchaseValue () {
			if (this.$refs.price.validatePrice(this.purchasePrice)) {
				axios.put(`/api/v0/orderrows/${this.orderrow.id}`, {
					'phone_purchase_price': this.purchasePrice,
				}).then(() => {
					inform(this.$gettext('Updated'));
					setTimeout(() => {
						window.location.reload();
					}, 300);
				}).catch((error) => {
					if (error.response.data.errors) {
						displayError(error.response.data.errors[0]);
					} else {
						displayError(this.$gettext('Something has gone wrong'));
						window.captureException(error);
					}
				});
			}
		}
	}

};
</script>

<style scoped>

</style>
